// src/store/actions/userActions.js
export const SET_TIME = "SET_TIME";

export const setUTime = (time) => {
  return {
    type: SET_TIME,
    payload: time,
  };
};
